export default __webpack_public_path__ + "static/FiraSans-Regular-f4eb295ecc2fb842d61c2f627f98ace7.ttf";